export const VERSION = "0.3";
